import { darken, lighten } from "@mui/material";

import { createTheme as createAmplifyTheme } from "@aws-amplify/ui-react";
import { resolveOrgPalette } from "./mui5themes";

export const awsTheme = (themeId = 0, mode = "light") => {
  const palette = resolveOrgPalette(themeId, mode);

  return createAmplifyTheme({
    name: "custom-theme",
    tokens: {
      colors: {
        black: {
          value: palette.commonground.contrastText,
        },
        font: {
          primary: { value: palette.commonground.contrastText },
          font: {
            interactive: {
              value: palette.commonground.contrastText,
            },
          },
        },
        brand: {
          primary: {
            10: lighten(palette.primary.main, 0.35),
            20: lighten(palette.primary.main, 0.3),
            30: lighten(palette.primary.main, 0.25),
            40: lighten(palette.primary.main, 0.2),
            50: lighten(palette.primary.main, 0.15),
            60: lighten(palette.primary.main, 0.1),
            70: lighten(palette.primary.main, 0.05),
            80: palette.primary.main,
            90: darken(palette.primary.main, 0.2),
            100: darken(palette.primary.main, 0.3),
          },
          secondary: {
            10: lighten(palette.secondary.main, 0.35),
            20: lighten(palette.secondary.main, 0.3),
            30: lighten(palette.secondary.main, 0.25),
            40: lighten(palette.secondary.main, 0.2),
            50: lighten(palette.secondary.main, 0.15),
            60: lighten(palette.secondary.main, 0.1),
            70: lighten(palette.secondary.main, 0.05),
            80: palette.secondary.main,
            90: darken(palette.secondary.main, 0.2),
            100: darken(palette.secondary.main, 0.3),
          },
        },
      },
    },
  });
};
